export enum MonthStatusEnum {
    OPEN = 'open',
    CLOSED = 'closed',
    INACTIVE = 'inactive',
}
